import DialogInfo from '~/components/dialog/info/DialogInfo.vue';

export const useAccountLogout = () => {
  const { t } = useI18n();
  const dialog = useDialogStore();

  const confirmLogout = () => {
    dialog.open(DialogInfo, {
      level: DialogLevel.Settings,
      iconHeader: 'logout',
      title: t('logout.title'),
      label: t('logout.confirm'),
      cancel: true,
      onCancel: () => dialog.close(),
      onConfirm: async () => {
        dialog.close();
        window.location.href = '/logout';
      },
    });
  };

  return {
    confirmLogout,
  };
};
